module.exports = __webpack_public_path__ + "img/dis.6be94cc3.png";